export enum ExportTypes {
    SLIDE_ELEMENT = 'SLIDE_ELEMENT',
    PRESENTATION = 'PRESENTATION',
}
